import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { WrongInvoiceService } from '../WrongInvoiceService';
import { TenantCompanyService } from '../../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../../../service/UserStorage';

import { FormatDisplay } from '../../../../shared/format';

import { ToastService } from '../../../../AppToast';
import { ConfirmDialogService } from '../../../../AppConfirmDialog';

import { useForm } from '../../../../shared/hooks/Form';
import { useCellEditing } from '../../../../shared/hooks/CellEditing';
import { useSign } from '../../../../shared/component/Sign';

import { DialogSelectInvoice } from '../../../hoa-don/component/DialogSelectInvoice';
import { get } from 'http';
import { TaxAuthorityService } from '../../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TaxAuthorityService';
import { useTranslation } from '../../../../shared/language';

export const DialogCrup = (props) => {

  const { t } = useTranslation();

  const { display, setDisplay, selectedItem, reloadLazyData } = props;

  const [tenantData, setTenantData] = useState(null);

  const [submitting, setSubmitting] = useState(null);
  const [wrongInvoiceDetail, setWrongInvoiceDetail] = useState([]);
  const [invoiceDetailValidate, setInvoiceDetailValidate] = useState(null);

  const [firstId, setFirstId] = useState(null);
  const [disableProperty, setDisableProperty] = useState(true);
  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);
  const [type, setType] = useState(1)
  const types = [
    { value: 1, translationKey: 'common.noticeFromTaxpayer' },
    { value: 2, translationKey: 'common.noticeFromTaxAuthority' }
  ];

  const typeInvoices = [
    { value: 1, translationKey: 'common.invoiceTypeN123' },
    { value: 2, translationKey: 'common.verifiedInvoiceQd1209' },
    { value: 3, translationKey: 'common.invoiceN51' },
    { value: 4, translationKey: 'common.preprintedInvoiceN123' }
  ];

  const properties = [
      { value: 4, translationKey: 'common.explanation' },
      { value: 6, translationKey: 'common.notice' }

  ];

  const { render: renderForm, setValue, valid: formValid, getValue } = useForm({
    fields: [
      { field: 'id', type: 'hidden' },
      { field: 'type', header: t('common.noticeType'), required: true, type: 'Dropdown', DropdownProps: { options: types, filter: true, resetFilterOnHide: true }, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9' },
      { field: 'documentNo', header: t('common.noticeNumber'), required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-4', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      {
        field: 'taxAuthorityNotificationNo', header: t('common.taxAuthorityNotificationNo'), required: type === 2, InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      {
        field: 'taxAuthorityNotificationDate', header: t('common.taxAuthorityNotificationDate'), required: type === 2, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      { field: 'taxAuthorityCode', type: 'hidden' },
      { field: 'taxAuthorityName', header: t('common.taxAuthorityReceiving'), required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { type: 'custom', className: 'md:col-12', body: <i>{t('common.taxAuthorityNoticeHint')} <a href="/#/he-thong/doanh-nghiep/thong-tin-doanh-nghiep" target="_blank">{t('common.view')}</a></i> },
      { field: 'taxpayers', header: t('common.taxpayerName'), required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxCode', header: t('common.taxCode'), required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'dateCreate', header: t('common.declarationDate'), required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'region', header: t('common.placeOfCreation'), required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' }
    ],
    layout: 'Horizontal'
  });

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      setTenantData(data);
    });
  }, []);
  const columns: any = [
    {
      field: 'index', header: t('common.sequenceNumber'), style: { textAlign: 'center' }, dataType: 'custom', customCell(rowData: any, rowIndex): any {
        return rowIndex + 1;
      }
    },
    { field: 'denominator', header: `${t('common.sampleNumber')} *`, editable: true, required: true, inputProps: { maxLength: 11 }, style: { minWidth: '100px', maxWidth: '100px' } },
    { field: 'invoiceSerial', header: `${t('common.symbol')} *`, editable: true, required: true, inputProps: { maxLength: 6 }, style: { minWidth: '80px', maxWidth: '80px' } },
    { field: 'invoiceNumber', header: `${t('common.invoiceNo')} *`, editable: true, required: true, inputProps: { maxLength: 8 }, style: { minWidth: '90px', maxWidth: '90px' } },
    { field: 'invoiceDate', header: `${t('common.invoiceDate')} *`, editable: true, required: true, dataType: 'date', style: { minWidth: '120px', maxWidth: '120px' } },
    {
      field: 'typeInvoice', header: `${t('common.invoiceTypeApplied')} *`, dataType: 'dropdown', editable: true, required: true, inputProps: { options: typeInvoices }, style: { minWidth: '200px', maxWidth: '200px' }
    },
    { field: 'reason', header: `${t('common.invoiceReason')} *`, editable: true, required: true, style: { minWidth: '120px' }, maxLength: 255 },
    { field: 'taxAuthorityCode', header: t('common.taxAuthorityIssuedCode'), editable: true, style: { minWidth: '160px', maxWidth: '160px' } }
  ];

  const { render: renderDataTable, selectedItem: editingItem, setSelectedItem: setEditingItem } = useCellEditing({
    dataKey: 'invoiceId',
    columns,
    items: wrongInvoiceDetail,
    onCellChange: (rowData, column, newValue) => {
      if (['denominator', 'invoiceSerial'].includes(column.field)) {
        newValue = newValue.toUpperCase();
      }
      const _items = [...wrongInvoiceDetail];
      for (const _item of _items) {
        if (_item._id === rowData._id) {
          _item[column.field] = newValue;
        } else if (firstId === rowData._id && ['typeInvoice', 'property', 'reason'].includes(column.field)) {
          _item[column.field] = newValue;
        }
      }
      setWrongInvoiceDetail(_items);
    }
  });

  const onShow = () => {
    if (selectedItem && selectedItem.id) {
      setDisableProperty(false);
      WrongInvoiceService.getDetail(selectedItem.id).then(data => {
        if (data.dateCreate) {
          data.dateCreate = new Date(data.dateCreate);
        }
        if (data.taxAuthorityNotificationDate) {
          data.taxAuthorityNotificationDate = new Date(data.taxAuthorityNotificationDate);
        }
        if (data.wrongInvoiceDetail && data.wrongInvoiceDetail.length) {
          data.wrongInvoiceDetail.forEach((item, index) => {
            item._id = `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
            if (item.invoiceDate) {
              item.invoiceDate = new Date(item.invoiceDate);
            }
          });
          data.wrongInvoiceDetail.sort((a, b) => {
            return a.invoiceNumber - b.invoiceNumber
          });
          setFirstId(data.wrongInvoiceDetail[0]._id);
        }
        setValue(data);
        setWrongInvoiceDetail(data.wrongInvoiceDetail);
      });
    } else {
      setDisableProperty(true);
      if (tenantData) {
        TaxAuthorityService.getByCode(tenantData.taxAuthorityCode).then(res => {
          setValue({
            type: 1,
            documentNo: `TB-${FormatDisplay.date(new Date(), 'DDMMYYYY_HHmm')}`,
            taxAuthorityCode: tenantData.taxAuthorityCode,
            taxAuthorityName: res.data.name,
            taxpayers: tenantData.name,
            taxCode: tenantData.useIdentityCard ? tenantData.identityCard : tenantData.taxCode,
            region: tenantData.province,
            dateCreate: new Date()
          });
        });
      }
      setWrongInvoiceDetail([]);
    }
  }

  const addItem = () => {
    const _wrongInvoiceDetail = [...wrongInvoiceDetail];
    _wrongInvoiceDetail.push({
      _id: `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}`,
      denominator: '',
      invoiceSerial: '',
      invoiceNumber: '',
      invoiceDate: null,
      typeInvoice: 1,
      reason: '',
      taxAuthorityCode: ''
    });
    setWrongInvoiceDetail(_wrongInvoiceDetail);
    setFirstId(_wrongInvoiceDetail[0]._id);
  }

  const deleteItem = () => {
    if (editingItem) {
      const _wrongInvoiceDetail = wrongInvoiceDetail.filter((f) => f._id !== editingItem._id);
      setWrongInvoiceDetail(_wrongInvoiceDetail);
      setEditingItem(null);
      if (_wrongInvoiceDetail.length) {
        setFirstId(_wrongInvoiceDetail[0]._id);
      } else {
        setFirstId(null);
      }
    }
  }

  const showDialogSelectInvoice = () => {
    setDisplaySelectInvoice(true);
  }

  const onAddSelectedItems = (items) => {
    if (items) {
      let _selectedItems;
      if (Array.isArray(items)) {
        _selectedItems = [...items];
      } else {
        _selectedItems = [items];
      }
      const _items = [...wrongInvoiceDetail];
      _selectedItems.forEach((selectedItem, index) => {

        let valid = true;

        _items.forEach(_item => {
          if (_item.id === selectedItem.id) {
            valid = false;
          }
        });

        if (valid) {
          _items.push({
            _id: `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`,
            id: selectedItem.id,
            invoiceId: selectedItem.id,
            denominator: selectedItem.invoiceSerial.substring(0, 1),
            invoiceSerial: selectedItem.invoiceSerial.substring(1, selectedItem.invoiceSerial.length),
            invoiceNumber: `${selectedItem.invoiceNumber}`,
            invoiceDate: new Date(selectedItem.invoiceDate),
            typeInvoice: 1,
            reason: '',
            taxAuthorityCode: selectedItem.taxAuthorityCode || ''
          });
        }
      });
      _items.sort((a, b) => {
        return a.invoiceNumber - b.invoiceNumber
      });
      setWrongInvoiceDetail(_items);
      setFirstId(_items[0]._id);
    }
  }

  const { renderSign, sign } = useSign({ onComplete: null });

  const validateWrongInvoiceDetail = () => {
    const _invoiceDetailValidate = [];
    wrongInvoiceDetail?.forEach((wrongInvoice, index) => {
      let validates = [];

      const { denominator, invoiceSerial } = wrongInvoice;

      if (wrongInvoice.typeInvoice === 1) {
        if (!(denominator?.length === 1 && parseInt(denominator) >= 1 && parseInt(denominator) <= 6)) {
          validates.push(t('validation.wrongInvoiceDenominatorRange'));
        }

        let validate;
        if (invoiceSerial?.length !== 6) {
          validate = t('validation.wrongInvoiceRelatedSerialLength');
        } else if (!['C', 'K'].includes(invoiceSerial[0].toUpperCase())) {
          validate = t('validation.wrongInvoiceFormChar');
        } else if (invoiceSerial.length >= 3 && (Number.isNaN(parseInt(invoiceSerial[1])) || Number.isNaN(parseInt(invoiceSerial[2])))) {
          validate = t('validation.wrongInvoiceYearChar');
        } else if (invoiceSerial.length >= 4 && !['T', 'M', 'G', 'H', 'B', 'N'].includes(invoiceSerial[3].toUpperCase())) {
          validate = t('validation.wrongInvoiceTypeChar');
        }
        if (validate) {
          validates.push(validate);
        }
      } else {

        let validate;
        if (denominator?.length !== 11) {
          validate = t('validation.wrongInvoiceDenominatorLength');
        } else if (denominator.length >= 2 && !['01', '02', '03', '04'].includes(`${denominator[0]}${denominator[1]}`)) {
          validate = t('validation.wrongInvoiceFirstTypeChars');
        } else if (denominator.length >= 6 && !['GTKT', 'GTTT', 'XKNB', 'HGDL'].includes(`${denominator[2]}${denominator[3]}${denominator[4]}${denominator[5]}`.toUpperCase())) {
          validate = t('validation.wrongInvoiceKindChars');
        } else if (denominator.length >= 7 && !['0', '1', '2', '3'].includes(denominator[6])) {
          validate = t('validation.wrongInvoiceCopiesChar');
        } else if (denominator.length >= 8 && !['/'].includes(denominator[7])) {
          validate = t('validation.wrongInvoiceSeparator');
        } else if (denominator.length >= 11 && !['001', '002', '003'].includes(`${denominator[8]}${denominator[9]}${denominator[10]}`)) {
          validate = t('validation.wrongInvoiceIssueSequence');
        }
        if (validate) {
          validates.push(validate);
        }

        validate = '';
        if (invoiceSerial.length !== 6) {
          validate = t('validation.wrongInvoiceSerialLength');
        } else if (invoiceSerial.length >= 2 && (!/^[A-EG-HK-NP-TVXYZ]$/.test(invoiceSerial[0].toUpperCase()) || !/^[A-EG-HK-NP-TVXYZ]$/.test(invoiceSerial[1].toUpperCase()))) {
          validate = t('validation.wrongInvoiceSerialPrefix');
        } else if (invoiceSerial.length >= 3 && !['/'].includes(invoiceSerial[2])) {
          validate = t('validation.wrongInvoiceSeparator');
        } else if (invoiceSerial.length >= 5 && (Number.isNaN(parseInt(invoiceSerial[3])) || Number.isNaN(parseInt(invoiceSerial[4])))) {
          validate = t('validation.wrongInvoiceSerialYear');
        } else if (invoiceSerial.length === 6 && !['E', 'P', 'T'].includes(invoiceSerial[5].toUpperCase())) {
          validate = t('validation.wrongInvoiceSerialType');
        }
        if (validate) {
          validates.push(validate);
        }
      }
      if (validates.length) {
        _invoiceDetailValidate.push(t('validation.wrongInvoiceLine', { line: index + 1, message: validates.join('<br/> - ') }));
      }
    });
    setInvoiceDetailValidate(_invoiceDetailValidate);
    return _invoiceDetailValidate.length;
  }

  const handleSubmit = () => {
    if (validateWrongInvoiceDetail() > 0) {
      return;
    }
    if (wrongInvoiceDetail && wrongInvoiceDetail.length) {
      let valid = true, orders = 1, _wrongInvoiceDetail = [];
      for (const wrongInvoice of wrongInvoiceDetail) {
        const _wrongInvoice = Object.assign({}, wrongInvoice);
        for (const column of columns) {
          if (column.required && (_wrongInvoice[column.field] === null || _wrongInvoice[column.field] === '')) {
            valid = false;
            ToastService.error(t('validation.required', { field: column.header }));
            break;
          }
        }
        if (!valid) {
          break;
        }
        _wrongInvoice.orders = orders;
        _wrongInvoice.invoiceDate = FormatDisplay.date(_wrongInvoice.invoiceDate, 'YYYY-MM-DDTHH:mm:ss');
        orders++;
        _wrongInvoiceDetail.push(_wrongInvoice);
      }
      if (valid && formValid() && !submitting) {

        setSubmitting(true);

        const data = getValue();
        data.wrongInvoiceDetail = _wrongInvoiceDetail;

        let method;
        if (data.id) {
          method = WrongInvoiceService.update(data.id, data);
        } else {
          method = WrongInvoiceService.create(data);
        }
        method.then(({ id }) => {
          ToastService.success();
          setDisplay(false);
          reloadLazyData();

          ConfirmDialogService.setProps({
            message: t('common.sendErrorNoticeQuestion'),
            header: t('common.signErrorNotice'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-primary',
            acceptLabel: t('common.confirm'),
            rejectLabel: t('common.sendLater'),
            accept: () => {
              sign({
                "CommandName": "SignSS04",
                "Id": data.id || id
              });
            }
          });
        }).finally(() => {
          setSubmitting(false);
        });
      }
    } else {
      ToastService.error(t('common.invoiceListInvalid'));
    }
  }

  useEffect(() => {
    setType(getValue().type)
  }, [getValue().type])

  return (
    <Fragment>
      <Dialog header={t('common.wrongInvoiceDeclaration')} visible={display} style={{ width: '92rem' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplay(false)} onShow={onShow}>
        <div className="grid">
          <div className="col-12">
            {renderForm()}
          </div>

          <div className="col-12">
            <b>{t('common.invoicesForErrorNotice')}</b>
          </div>

          {invoiceDetailValidate?.length > 0 && <div className="col-12">
            <div className="p-message p-component p-message-error p-message-enter-done m-0">
              <div className="p-message-wrapper">
                <span className="p-message-detail">
                  {invoiceDetailValidate.map((validate, index) => <div key={index} dangerouslySetInnerHTML={{ __html: validate }}></div>)}
                </span>
              </div>
            </div>
          </div>}

          <div className="col-fixed" style={{ width: '300px' }}>
            <Button label={t('common.selectInvoice')} className="p-button-outlined p-button-sm mr-2" onClick={showDialogSelectInvoice} />
            <Button label={t('common.addLine')} className="p-button-outlined p-button-success p-button-sm mr-2" onClick={addItem} />
            <Button label={t('common.deleteLine')} className="p-button-outlined p-button-danger p-button-sm" onClick={deleteItem}
              disabled={!editingItem} />
          </div>
          <div className="col flex align-items-center">
            <i>({t('common.manualInvoiceHint')})</i>
          </div>
          <div className="col-12">
            {renderDataTable()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => {
            setDisplay(false);
            setInvoiceDetailValidate(null);
          }} className="p-button-text p-button-sm" />
          <Button label={t('common.save')} icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
        </div>
      </Dialog>
      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="checkbox"
        sendTaxStatus="4" />
      {renderSign()}
    </Fragment>
  );
}
